module.exports = __webpack_public_path__ + "img/node-create.6a5a4603.png";